// extracted by mini-css-extract-plugin
export default {"headerForm":"Authenticate_headerForm__85ahU","submitButton":"Authenticate_submitButton__un5T1","errorBanner":"Authenticate_errorBanner__hV79C"};